export default "__VITE_ASSET__BAuf5ExS__"